// extracted by css-extract-rspack-plugin
export default {"removeAction":"guide-item-swipe-action-module__removeAction___WBgBP","actionIcon":"guide-item-swipe-action-module__actionIcon___u0pPX"};